import { Text } from '@volkswagen-onehub/components-core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Email, NombreApellidos } from 'src/components';
import { LayoutTemplate, useFaContent } from 'src/feature-app';
import { ConfirmacionProspects } from './ConfirmacionProspects';
import { ProspectsVentaForm } from './ProspectsVentaForm';

enum ProspectsSteps {
	Email,
	NombreApellido,
	Confirmacion,
}

export function ProspectsMatchEmbedded() {
	const faContent = useFaContent();
	const dispatch = useDispatch();

	const steps = [
		{
			title: (
				<>
					<Text bold>¿A qué email</Text> quieres que te enviemos esta
					configuración?
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<div>
							<Email required />
						</div>
					}
				/>
			),
			screenIndex: ProspectsSteps.Email,
			name: 'Email',
			outputs: ['email'],
			outputsText: ['email'],
		},
		{
			title: (
				<>
					Para hacerlo, nos gustaría saber{' '}
					<Text bold>quién eres</Text>
				</>
			),
			fields: (
				<LayoutTemplate
					element={
						<div>
							<NombreApellidos />
						</div>
					}
				/>
			),
			screenIndex: ProspectsSteps.NombreApellido,
			name: 'NombreApellido',
			outputs: ['name', 'surname', 'secondSurname'],
			outputsText: ['name', 'surname', 'secondSurname'],
		},

		{
			fields: <ConfirmacionProspects />,
			screenIndex: ProspectsSteps.Confirmacion,
			name: 'Confirmacion',
			isLastStep: true,
			hidePreviousStep: true,
		},
	];

	return (
		<ProspectsVentaForm
			customSteps={steps}
			updatedFormData={{
				fields: { formName: 'prospect-match' },
			}}
		/>
	);
}
